import React from 'react'
import { API_HOST, axiosRequest } from './../../constants/server.constant';
import Axios from 'axios';
import $ from 'jquery'

class BareMetalIndex extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            bmrId : "",
            bmrList : [],
            emailToggle : false,
            regionToggle : false,
            unitsToggle : false,
            dateToggle:true,
            planToggle:false,
            statusToggle:false,
            isAction : false,
            message : "",
            msgType:"",
            showLoader : true,
            totalRequest : 0,
            bmStatus : "pending",
            errorDisplay:false,
            isConfirm:false,
            currentStatus:"",
            currentBmId:"",
            currentRegion : "",
            flavourList : []
        }
        this.handleInputs = this.handleInputs.bind(this)
        this.escfunction = this.escfunction.bind(this)
    }
    escfunction(event){
        if(event.keyCode === 27) {
           this.setState({
               isConfirm:false
           })
          $("body").removeClass("no_scroll");
          
        }
    }
    componentDidMount = ()=>{
        document.addEventListener("keyup", this.escfunction, false);
        document.styleSheets[1].disabled = true
        this.loadCss()
       
    }
    componentWillUnmount(){
        document.removeEventListener("keyup",this.escfunction,false)
        document.styleSheets[1].disabled = false
        var disbale1 = "bmrService-theme.css"
        var disbale2 = "bmrService-layout.css"
        var disbale3 = "bmrService-retina.css"
        var disbale4 = "bmrService-datepicker.css"
        Object.values(document.styleSheets).forEach(sheet => {
            let sheetLink = sheet.href
            if(sheetLink !== null){
                let urlLastName =  sheetLink.split("/").pop()
                let sheetName = urlLastName.split("?")

                if (disbale1.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if (disbale2.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if (disbale3.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if (disbale4.indexOf(sheetName[0]) > -1) sheet.disabled = true;
            }
           
          });
        
    }
    loadCss = ()=>{
        document.title = "IDrive® Compute | IDrive Homepage"
        const link = document.createElement("link")
        link.href = "https://www.idrivecompute.com/bmr-service-infra/include/css/bmrService-theme.css?v=1.0"
        link.rel = "stylesheet"
        link.type = "text/css"
         document.head.appendChild(link)

        const link1 = document.createElement("link")
        link1.href = "https://www.idrivecompute.com/bmr-service-infra/include/css/bmrService-layout.css?v=1.0"
        link1.rel = "stylesheet"
        link1.type = "text/css"
        document.head.appendChild(link1)

        const link2 = document.createElement("link")
        link2.href = "https://www.idrivecompute.com/bmr-service-infra/include/css/bmrService-retina.css?v=1.0"
        link2.rel = "stylesheet"
        link2.type = "text/css"
        document.head.appendChild(link2)

        const link3 = document.createElement("link")
        link3.href = "https://www.idrivecompute.com/bmr-service-infra/include/css/bmrService-datepicker.css?v=1.0"
        link3.rel = "stylesheet"
        link3.type = "text/css"
        document.head.appendChild(link3)
        setTimeout(()=>{
            this.setState({showLoader:false})
        },300)
        this.getBmData()
      
    }

    getBmData = ()=>{
        this.setState({
            isAction:true
        })
        Axios.get(API_HOST+"/baremetal/infrabmdata").then(resp=>{
            console.log(resp)
            let res = resp.data
            res.sort(function(a,b){
                return new Date(a.bm_requested_on) - new Date(b.bm_requested_on);
            })
            let bmList = []
            for(let i=0;i<res.length;i++){
                let d = new Date(res[i].bm_requested_on)
                let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                });
                let obj = {
                    "bmrId" : res[i].id,
                    "email" : res[i].user.email,
                   "bmrUnits" : res[i].bmrUnits,
                    region : {
                        "name" :res[i].region.name,
                        "region_id" : res[i].region.region_id
                    },
                    flavour : {
                        "vcpus" : res[i].flavour.vcpus,
                        "disk" : res[i].flavour.disk,
                        "ram" : res[i].flavour.ram,
                        "processor":res[i].flavour.processor,
                        "disk_type":res[i].flavour.disk_type,
                        "threads" : res[i].flavour.threads,
                        "flavourId" : res[i].flavour.flavour_id
                    },

                    "bm_requested_on" : createdDate,
                    "bmrStatus" : res[i].bmrStatus
                }
                bmList.push(obj)
            }
            this.setState({
                bmrList:bmList,
                totalRequest : bmList.length,
                isAction:false
            })
        }).catch(err=>{
            this.setState({
                message : "Error while fetching details",
                errorDisplay : true,
                isAction:false,
                msgType:"error"
            })
        })
    }
    handleInputs=   (event,bmrId,region,flavourId)=>{
        var currentVal = $(event.currentTarget).closest('tr').find('.request-select option:selected').text();
        if(currentVal == "Pending"){
            this.setState({
                errorDisplay : true,
                message : "Selected status cannot be updated",
                msgType:"error"
            })
            setTimeout(()=>{
                this.setState({
                    errorDisplay:false
                })
            },10000)
            return
        }
        else{
            $("body").addClass("no_scroll");
            this.setState({
                isAction:true
            })
            
            Axios.get(API_HOST+"/flavors/getflavoursbyregion/"+region+"?type=baremetal",axiosRequest).then(resp=>{
                let res = resp.data;
                let obj = [];
                for(let i=0;i<res.length;i++){
                    let data_json = {
                        "vcpus" : res[i].vcpus,
                        "disk" : res[i].disk,
                        "ram" : res[i].ram,
                        "processor":res[i].processor,
                        "disk_type":res[i].disk_type,
                        "threads" : res[i].threads,
                        "flavourId" : res[i].flavour_id,
                        "sortNum":res[i].flavour_id === flavourId?"0":"1"
                    }
                    obj.push(data_json)
                }
                obj.sort(function(a,b){
                    if(a.sortNum > b.sortNum) return 1;
                    else if(a.sortNum < b.sortNum) return -1;
                    else return 0;
                })
                this.setState({
                    isConfirm:true,
                    currentBmId : bmrId,
                    currentStatus: currentVal,
                    currentRegion : region,
                    currentFlavour:flavourId,
                    getSelectedFlavour : flavourId,
                    currentOption : currentVal,
                    flavourList:obj,
                    errorDisplay : false,
                    message : "",
                    msgType:"",
                    isAction:false
                })
               
            })
            .catch(error=>{
                this.setState({
                    isAction:false
                })
            })
        }
       
        
    }  
    
    submitUpdate(){
        $("body").removeClass("no_scroll")
        this.setState({
            isAction:true,
            isConfirm:false
        })
        let currentVal = ""
        if(this.state.currentStatus == "Available"){
            currentVal = "available"
        }
        else{
            currentVal = "canceled"
        }
        Axios.post(API_HOST+"/baremetal/updatebm/"+this.state.currentBmId+"/"+currentVal+"?flavourId="+this.state.currentFlavour).then(resp=>{
            this.setState({
                isAction:false,
                message : "Bare Metal status updated successfully",
                errorDisplay : true,
                msgType:"",
            })
            setTimeout(()=>{
                this.setState({
                    errorDisplay:false
                })
            },10000)
            this.getBmData()
        }).catch(err=>{
            this.setState({
                message : "Error while Updating details",
                errorDisplay : true,
                msgType:"",
                isAction:false
            })
        })
    }
    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    }

    setSortable=(param)=>{
        let items = [...this.state.bmrList]

        if(param[0] == "mail"){
            if(this.state.emailToggle){
                items.sort(function(a,b){
                    if(a.email < b.email) { return -1; }
                    if(a.email > b.email) { return 1; }
                    return 0;
                })
                
            }
            else{
                items.sort(function(a,b){
                    if(a.email < b.email) { return 1; }
                    if(a.email > b.email) { return -1; }
                    return 0;
                })
                
            }
            this.setState({
                bmrList : items,
                emailToggle : !this.state.emailToggle,
                regionToggle : false,
                unitsToggle : false,
                dateToggle:false,
                planToggle:false,
                statusToggle:false,
            })
        }
        else if(param[0] == "region"){
            if(this.state.regionToggle){
                items.sort(function(a,b){
                    if(a.region.name < b.region.name) { return -1; }
                    if(a.region.name > b.region.name) { return 1; }
                    return 0;
                })
                
            }
            else{
                items.sort(function(a,b){
                    if(a.region.name < b.region.name) { return 1; }
                    if(a.region.name > b.region.name) { return -1; }
                    return 0;
                })
                
            }
            this.setState({
                bmrList : items,
                emailToggle : false,
                regionToggle : !this.state.regionToggle,
                unitsToggle : false,
                dateToggle:false,
                planToggle:false,
                statusToggle:false,
            })
        }
        else if(param[0] == "units"){
            if(this.state.unitsToggle){
                items.sort(function(a,b){
                    if(a.bmrUnits < b.bmrUnits) { return -1; }
                    if(a.bmrUnits > b.bmrUnits) { return 1; }
                    return 0;
                })
                
            }
            else{
                items.sort(function(a,b){
                    if(a.bmrUnits < b.bmrUnits) { return 1; }
                    if(a.bmrUnits > b.bmrUnits) { return -1; }
                    return 0;
                })
                
            }
            this.setState({
                bmrList : items,
                emailToggle : false,
                regionToggle : false,
                unitsToggle : !this.state.unitsToggle,
                dateToggle:false,
                planToggle:false,
                statusToggle:false,
            })
        }
        else if(param[0] == "date"){
            if(this.state.dateToggle){
                items.sort(function(a,b){
                    return new Date(b.bm_requested_on) - new Date(a.bm_requested_on);
                })
                
            }
            else{
                items.sort(function(a,b){
                    return new Date(a.bm_requested_on) - new Date(b.bm_requested_on);
                })
                
            }
            this.setState({
                bmrList : items,
                emailToggle : false,
                regionToggle : false,
                unitsToggle : false,
                dateToggle:!this.state.dateToggle,
                planToggle:false,
                statusToggle:false,
            })
        }
        else if(param[0] == "status"){
            if(this.state.statusToggle){
                items.sort(function(a,b){
                    if(a.bmrStatus < b.bmrStatus) { return -1; }
                    if(a.bmrStatus > b.bmrStatus) { return 1; }
                    return 0;
                })
                
            }
            else{
                items.sort(function(a,b){
                    if(a.bmrStatus < b.bmrStatus) { return 1; }
                    if(a.bmrStatus > b.bmrStatus) { return -1; }
                    return 0;
                })
                
            }
            this.setState({
                bmrList : items,
                emailToggle : false,
                regionToggle : false,
                unitsToggle : false,
                dateToggle:false,
                planToggle:false,
                statusToggle:!this.state.statusToggle,
            })
        }
        
    }

    setRadioButtonValue = (flavourId)=>{
        this.setState({
            getSelectedFlavour : flavourId,
            currentFlavour : flavourId
        })
    }

    render(){
        if(this.state.showLoader){
            return(
                <div className="full_page_loader" style={{display: this.state.showLoader?"block" :"none"}}><div className="loader_icon"></div></div>
            )
        }
        return(
            <body>
                <div className="full_page_loader" style={{display: this.state.isAction?"block" :"none"}}><div className="loader_icon"></div></div>
                <div className={this.state.msgType == "error"?"common_user_message error":"common_user_message success"} style = {{display : this.state.errorDisplay?"block":"none"}}>
                    <div className="message_content">
                    <p>{this.state.message}</p>
                    <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick = {()=>{this.setState({errorDisplay:false,message:""})}}></span>
                    </div>
                </div>
                <header className="header">
                    <div className="inner-wrap" >
                       <div className="header-menu">
                          <ul>
                             <li style = {{display:"none"}}>Request ID: b_bmrService </li>
                             <li style = {{display:"none"}}>|<a className="edit_profile" href="#">Change Password</a></li>
                             <li className="logout" style = {{display:"none"}}><a href="bmrServiceLogout">Logout</a></li>
                          </ul>
                       </div>
                       <a className="logo" href="https://www.idrivecompute.com" target="_blank"></a>
                    </div>

                </header>
                <section>
                <div className="dashboard-wrap">
                <div className="clear"></div>
                <section className="rgt-wrap">
                    <div className="lft-link-wrap">
                    </div>
                    <div className="inside-wrap">
                        <div className="con-satatic">
                            <a name="sales-report" id="sales-report"> </a>
                            <div className="con-title">
                            <div className="common_msg error_msg" style = {{display : "none"}}>
                                <p>{this.state.message}</p>
                                <a className="close_info" href = "#" onClick = {(e)=>{e.preventDefault();this.setState({errorDisplay:false,message:""})}}><img width="16" height="16" title="Close" alt="close" src="https://www.idrivecompute.com/bmr-service-infra/include/images/close.png" /></a> 
                            </div>
                            <div className="brd-box">
                                <div className="sales-table">
                                <div className="sales-tableHead">
                                    <div className="dashboard-title">
                                        <h1>Bare Metal Status Tracking Dashboard</h1>
                                    </div>
                                    <div className="reports-view">
                                        <ul>
                                        <li className="totalUsers"> Total Request(s): <span>{this.state.totalRequest}</span> </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="clear"></div>
                                <div className="scroll-wrap">
                                    <div className="scroll-box">
                                        <table className="report-table" cellSpacing="0">
                                            <thead className="table-header">
                                                <tr>
                                                <th className="col col-email" onClick = {(event)=>{this.headerSortClick(event);this.setSortable(["mail"])}}>Email ID<span className="sort_icon"></span></th>
                                                <th className="col col-region" onClick = {(event)=>{this.headerSortClick(event);this.setSortable(["region"])}}>Region<span className="sort_icon"></span></th>
                                                <th className="col col-plan" >Plan</th>
                                                <th className="col col-unit" onClick = {(event)=>{this.headerSortClick(event);this.setSortable(["units"])}}>Unit(s)<span className="sort_icon"></span></th>
                                                <th className="col col-crdate" onClick = {(event)=>{this.headerSortClick(event);this.setSortable(["date"])}}>Requested On<span className="sort_icon active "></span></th>
                                                <th className="col col-status" onClick = {(event)=>{this.headerSortClick(event);this.setSortable(["status"])}}>Status<span className="sort_icon"></span></th>
                                                <th className="col col-action">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-inner-wrap">
                                                {this.state.bmrList.map((bmr,index)=>
                                                     <tr key = {index} className={bmr.bmrStatus == "pending"?"pending_requested":bmr.bmrStatus == "available"?"available_requested":"cancel_requested"}>
                                                        <td className="col col-email">
                                                            <div className="email-blk">
                                                                <div className="email_icon"><span>{bmr.email.charAt(0).toUpperCase()}</span></div>
                                                                <p><a href="#" onClick={e => e.preventDefault()}>{bmr.email}</a></p>
                                                            </div>
                                                        </td>
                                                        <td className="col col-region">
                                                            <p>{bmr.region.name}({bmr.region.region_id})</p>
                                                        </td>
                                                        <td className="col col-plan">
                                                            <p><b>{bmr.flavour.processor}</b> Processor <b>{bmr.flavour.vcpus}</b> cores / <b>{bmr.flavour.threads}</b> threads, {bmr.flavour.disk < 1024 ? bmr.flavour.disk + " GB ":(Math.round((bmr.flavour.disk/1024) * 1000) / 1000) + " TB "} {bmr.flavour.disk_type} Storage, {bmr.flavour.ram/1024}GB RAM</p>
                                                        </td>
                                                        <td className="col col-unit">{bmr.bmrUnits}</td>
                                                        <td className="col col-crdate">{bmr.bm_requested_on}</td>
                                                        {bmr.bmrStatus == "pending"?
                                                            <td className="col col-status pending" id = "statusTD">

                                                                <div className="table-dropdown">
                                                                    <label className="request-dropdown">
                                                                        <select className="request-select" name = "bmStatus" size="1">
                                                                        <option value="pending" selected="selected">Pending</option>
                                                                        <option value="available">Available</option>
                                                                        <option value="canceled">Canceled</option>
                                                                        </select>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            :
                                                            bmr.bmrStatus == "available"?
                                                            <td className="col col-status available">Available</td>
                                                            :<td className="col col-status cancel">Canceled</td>

                                                        }
                                                     
                                                      <td className="col col-action">
                                                          {bmr.bmrStatus == "pending"?
                                                          <button className="btn btn_blue" onClick = {(e)=>this.handleInputs(e,bmr.bmrId,bmr.region.region_id,bmr.flavour.flavourId)}>Update Request</button>:""}
                                                      </td>
                                                  </tr>
                                                )}
                                               
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer>
                    <div className="wrapper">
                    <p>&copy;IDrive Inc.</p>
                    </div>
                </footer>
                </div>
                </section>
                <div className="master_wrapper update_request_popup" style={{display: this.state.isConfirm?"block":"none" }}>
                     <div className="shadow_container"></div>
                     <div className="popup_wrapper">
                        <div className="first_pos_container plan_listCtnr">
                           <div className="sec_pos_container">
                              <div id="" className="popup_container update_request main_acc_cancel popLeft" style={{display: "block"}}>
                                 <form action="" method="post" name="cancel">
                                    <section className="popup_header">
                                    {this.state.currentOption =="Available"?
                                      <h2 className=""> Update Request</h2>
                                    :
                                       <h2 className="">Confirmation</h2>}
                                       <p class="row_description" style = {{display:this.state.currentOption =="Available"?"":"none"}}>Confirm the availability of the requested plan. Choose a new plan if the requested plan is currently unavailable.</p>
                                       <span className="popup_close_btn hide_popup" onClick = {()=>{this.setState({isConfirm:false});$("body").removeClass("no_scroll")}}></span>
                                    </section>
                                    <section className="popup_content">
                                       <div className="update_request_box">
                                          <p style={{display: "none"}} id="" className="err_msg"></p>
                                          <div className="editPro">
                                             <div className="row-span pass_hide" style={{display: "block"}}>
                                                {this.state.currentOption =="Available"?
                                                ""
                                                :
                                                <p className="row_description">Selected bare metal request will be updated as {this.state.currentStatus}</p> 
                                                }
                                                
                                                <div class="sel_plan" style = {{display:this.state.currentOption =="Available"?"":"none"}}>
                                                   <div class="customPlans_radio_wrap">
                                                       {this.state.flavourList.map(flavour=>
                                                            <div class="radio_ctnr" onClick = {()=>this.setRadioButtonValue(flavour.flavourId)}>
                                                                <label class={this.state.getSelectedFlavour == flavour.flavourId?"custom_radiobox active":"custom_radiobox"}><b>{flavour.processor}</b> Processor <b>{flavour.vcpus}</b> cores / <b>{flavour.threads}</b> threads, {flavour.disk < 1024 ? flavour.disk + " GB ":(Math.round((flavour.disk/1024) * 1000) / 1000) + " TB "} {flavour.disk_type} Storage, {flavour.ram/1024}GB RAM
                                                                    <input type="radio" name="plan_options" value = {flavour.flavourId}
                                                                    checked = {this.state.currentFlavour == flavour.flavourId}
                                                                    />
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        )}
                                                     
                                                    
                                                   </div>

                                                </div> 
                                             </div>
                                            
											 
											 <div className="row-span fb_row" style={{display: "block"}}>
												<div className="footer_box">
												
														<div className="fb_row1_cancel">
															<div className="fb_row1" >
																<input type="button" className="red_btn" value="Cancel Request"/>
															</div>
														</div>
													
													 <div className="fb_row2">
														<input type="button" className="cancl" value="Cancel" onClick = {()=>{this.setState({isConfirm:false});$("body").removeClass("no_scroll")}}/>
														<input type="button" className="send submit" value="Confirm"onClick = {()=>this.submitUpdate()} />
													 </div>
												</div>
											 </div>
                                          </div>
                                       </div>
                                    </section>
                                 </form>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
            </body>
        )
    }
}

export default BareMetalIndex;